export default "__VITE_ASSET__HHWJqE0k__"